module.exports = __webpack_public_path__ + "img/tr.a3e8de07.png";